import { render, staticRenderFns } from "./ui-page.vue?vue&type=template&id=26c96be5&scoped=true"
import script from "./ui-page.vue?vue&type=script&lang=js"
export * from "./ui-page.vue?vue&type=script&lang=js"
import style0 from "./ui-page.vue?vue&type=style&index=0&id=26c96be5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c96be5",
  null
  
)

export default component.exports